import { TONE_CLASSES } from "../assets/assetUtils";

const BLUE = "text-blue-700 bg-blue-50 border-blue-200 dark:text-blue-400 dark:bg-blue-950/30 dark:border-blue-800";

export const STOCK_STATE = {
  ok: { label: "In stock", cls: TONE_CLASSES.ok },
  low: { label: "Low stock", cls: TONE_CLASSES.soon },
  out: { label: "Out of stock", cls: TONE_CLASSES.overdue },
  on_order: { label: "On order", cls: BLUE },
};

export const PO_STATUS = {
  draft: { label: "Draft", cls: "text-foreground bg-muted border-border" },
  sent: { label: "Sent", cls: BLUE },
  part_received: { label: "Part received", cls: TONE_CLASSES.soon },
  received: { label: "Received", cls: TONE_CLASSES.ok },
  cancelled: { label: "Cancelled", cls: "text-muted-foreground bg-muted/40 border-border" },
};

export const MOVEMENT_LABEL = { receipt: "Received", issue: "Issued", transfer: "Transferred", adjust: "Stock count", return: "Returned" };
export const MOVEMENT_TONE = { receipt: TONE_CLASSES.ok, issue: TONE_CLASSES.soon, transfer: BLUE, adjust: TONE_CLASSES.none, return: TONE_CLASSES.ok };

export const money = (n) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const qty = (n) => Number(n || 0).toLocaleString("en-GB", { maximumFractionDigits: 3 });
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const StatePill = ({ state, testid }) => {
  const s = STOCK_STATE[state] || STOCK_STATE.ok;
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${s.cls}`} data-testid={testid}>{s.label}</span>;
};
export const PoStatusPill = ({ status, testid }) => {
  const s = PO_STATUS[status] || PO_STATUS.draft;
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium whitespace-nowrap ${s.cls}`} data-testid={testid}>{s.label}</span>;
};
export const MovePill = ({ type }) => <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${MOVEMENT_TONE[type] || TONE_CLASSES.none}`}>{MOVEMENT_LABEL[type] || type}</span>;

export const Spinner = () => <div className="flex justify-center py-12"><div className="animate-spin h-6 w-6 border-2 border-primary border-t-transparent rounded-full" /></div>;
